import { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./screens/login";
import Register from "./screens/register";
import Dashboard from "./screens/dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
// import LineProtectedRoute from "./components/LineProtectedRoute";
import Profile from "./screens/profile";
import { SessionProvider } from "./contexts/session-context";
import "./index.css";
import DonationList from "./screens/donation_list";
import ReceiveDonation from "./screens/receivedonation";
import SendDonation from "./screens/senddonation";
import ForgotPassword from "./screens/forgotpassword";

function useViewportFix() {
  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
    setVh();
    window.addEventListener("resize", setVh);
    window.addEventListener("orientationchange", setVh);
    return () => {
      window.removeEventListener("resize", setVh);
      window.removeEventListener("orientationchange", setVh);
    };
  }, []);
}

/**
 * ติด class ให้ <html> เมื่อเปิดใน In-App Browser (เช่น LINE/FB/IG)
 * เผื่อใช้เขียน CSS เฉพาะกรณีได้ (ถ้าต้องการ)
 */
function useInAppBrowserClass() {
  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    const inLine = ua.includes("line");
    const inFb = ua.includes("fbav") || ua.includes("fban");
    const inIg = ua.includes("instagram");
    if (inLine || inFb || inIg) {
      document.documentElement.classList.add("in-app");
      return () => document.documentElement.classList.remove("in-app");
    }
  }, []);
}

export default function App() {
  useViewportFix();
  useInAppBrowserClass();

  return (
    <SessionProvider>
      <div className="min-h-[calc(var(--vh,1vh)*100)] bg-[#FFFF]">
        <Routes>
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot_password" element={<ForgotPassword />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/donation_list" element={<DonationList />} />
            <Route path="/receive_donation" element={<ReceiveDonation />} />
            <Route path="/send_donation" element={<SendDonation />} />
          </Route>
          <Route path="*" element={<div className="p-6 text-white">404 Not Found</div>} />
        </Routes>
      </div>
    </SessionProvider>
  );
}
